// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__23Ys3","fileBtn":"File_fileBtn__366ll","closeBtn":"File_closeBtn__1Hrh2","fileSelected":"File_fileSelected__1d04G","disabled":"File_disabled__2ViOI"};